import { useState } from "react";
import { subscribeUser } from "../../store/subscribeSlice";
import { useDispatch } from "react-redux";
import Contact from "./Contact";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const [subValue, setSubValue] = useState("");
  const dispatch = useDispatch();
  const [subscribed, setSubscribed] = useState("");
  const [isContact, setIsContact] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSubValue(e.target.value);
  };

  const handleSubscription = async () => {
    if (!subValue) return;
    const res = await dispatch(subscribeUser({ Email: subValue }));
    if (res.payload?.success) {
      setSubValue("");
      setSubscribed("🎉 Congratulations! You have subscribed to JobIntelPro");

      setTimeout(() => {
        setSubscribed("");
      }, 3000);
    }
  };

  return (
    <>
      {subscribed && (
        <div className="mt-8 fixed top-5 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg z-50">
          {subscribed}
        </div>
      )}

      <footer className="bg-gradient-to-r from-indigo-600 to-teal-500 text-white border-t mt-10">
        <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1 */}
          <div className="flex flex-col gap-3">
            {/* <h3 className="font-semibold text-lg mb-2">About & Privacy</h3> */}
            <a href="/about" className="hover:text-yellow-300 transition">
              About Us
            </a>
            <a
              href="/privacy-policy"
              className="hover:text-yellow-300 transition"
            >
              Privacy Policy
            </a>
          </div>

          {/* Column 2: Center Post Job */}
          {/* <div className="flex flex-col justify-center items-center gap-3">
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                setIsModalOpen(true);
              }}
              className="hover:text-yellow-300 transition"
            >
              Contents
            </a>
          </div> */}

          <div className="flex flex-col gap-3">
            {/* <h3 className="font-semibold text-lg mb-2">Contact & Terms</h3> */}
            <a href="/blog" className="hover:text-yellow-300 transition">
              Blogs
            </a>
            <a
              href="#!"
              onClick={(e) => {
                e.preventDefault();
                setIsModalOpen(true);
              }}
              className="hover:text-yellow-300 transition"
            >
              Contents
            </a>
          </div>

          {/* Column 3 */}
          <div className="flex flex-col gap-3">
            {/* <h3 className="font-semibold text-lg mb-2">Contact & Terms</h3> */}
            <a
              href="#!"
              className="hover:text-yellow-300 transition"
              onClick={(e) => {
                e.preventDefault();
                setIsContact(true);
              }}
            >
              Contact Us
            </a>
            <a
              href="/terms-of-service"
              className="hover:text-yellow-300 transition"
            >
              Terms of Service
            </a>
          </div>
        </div>

        {/* Subscription Section */}
        <div className="max-w-7xl mx-auto px-6 py-6 border-t  flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-semibold text-white">
            Stay Connected – Subscribe for Job Updates
          </p>
          <div className="flex w-full md:w-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="border px-3 py-2 rounded-l-md w-full text-black placeholder-gray-500"
              onChange={handleChange}
              value={subValue}
            />
            <button
              onClick={handleSubscription}
              className="bg-yellow-400 text-indigo-800 px-4 rounded-r-md hover:bg-yellow-500 transition"
            >
              Subscribe
            </button>
          </div>
        </div>
      </footer>

      <Contact isOpen={isContact} onClose={() => setIsContact(false)} />

      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={() => setIsModalOpen(false)} // Close when clicking outside
        >
          <div
            className="bg-white dark:bg-gray-700 p-8 rounded-xl relative max-w-3xl w-full"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                Select Option
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-gray-900 dark:hover:text-white text-3xl"
              >
                ✕
              </button>
            </div>

            {/* Divider */}
            <hr className="border-gray-300 dark:border-gray-600 mb-6" />
            <div className="flex flex-col gap-4 w-full">
              <button
                onClick={() => {
                  navigate("/write-blog");
                  setIsModalOpen(false);
                }}
                className="w-full relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800"
              >
                <span className="w-full text-center relative px-5 py-3 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-transparent group-hover:dark:bg-transparent">
                  Write a Blog
                </span>
              </button>
              <button
                onClick={() => {
                  navigate("/postjob");
                  setIsModalOpen(false);
                }}
                className="w-full relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800"
              >
                <span className="w-full text-center relative px-5 py-3 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-transparent group-hover:dark:bg-transparent">
                  Post Job
                </span>
              </button>

              <button
                onClick={() => {
                  navigate("/add-hackathon");
                  setIsModalOpen(false);
                }}
                className="w-full relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-teal-300 to-lime-300 group-hover:from-teal-300 group-hover:to-lime-300 dark:text-white dark:hover:text-gray-900 focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-lime-800"
              >
                <span className="w-full text-center relative px-5 py-3 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-transparent group-hover:dark:bg-transparent">
                  Add Hackathons
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
